import clsx from "clsx";
import type { LucideIcon } from "lucide-react";

/**
 * The icon that leads a status pill: a small circle in the pill's own
 * colour. Both the glyph and the circle use currentColor (the circle at ~16%
 * via color-mix), so one component fits every tone and every theme without
 * per-status classes.
 */
export function PillIcon({ icon: Icon, className }: { icon: LucideIcon; className?: string }) {
  return (
    <span
      aria-hidden
      className={clsx("inline-grid h-4 w-4 shrink-0 place-items-center rounded-full", className)}
      style={{ background: "color-mix(in srgb, currentColor 16%, transparent)" }}
    >
      <Icon size={10} strokeWidth={2.5} />
    </span>
  );
}
